import { render, staticRenderFns } from "./subjectStatistics.vue?vue&type=template&id=e98eda14&scoped=true"
import script from "./subjectStatistics.vue?vue&type=script&lang=js"
export * from "./subjectStatistics.vue?vue&type=script&lang=js"
import style0 from "./subjectStatistics.vue?vue&type=style&index=0&id=e98eda14&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e98eda14",
  null
  
)

export default component.exports